<template>
	<div class="question-container">
		<div v-if="!isBusyCheckingCredit">
			<div
				class="question-text plaidQuestion"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>

			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>

			<div class="input-text">
				<div
					v-if="plaidLinkRef.linkSuccess"
					id="plaid-success-text"
				>
					<p>Your identity has been successfully verified.</p>
				</div>
			</div>

			<LoaderComponent v-if="plaidLinkRef && plaidLinkRef.isBusy"></LoaderComponent>
		</div>

		<div class="question-continue-button">
			<!--<div class="continue-without-plaid">
                <button v-if="!plaidLinkRef.linkSuccess"
                        class="button btn-text"
                        :style="{background: theme[procedeWithoutPlaidLink.style.background], color: theme[procedeWithoutPlaidLink.style.text]}"
                        @click="procedeWithoutPlaidLink.actions(null, [null], data.question, toggleLoading)"
                        v-html="data.question.getLocalizationDisplay(procedeWithoutPlaidLink.label, data.language)">
                </button>
            </div>-->

			<button
				v-if="plaidLinkRef.linkSuccess && !plaidLinkRef.isBusy"
				class="button"
				:style="{
					background: theme[continueBtn.style.background],
					color: theme[continueBtn.style.text],
				}"
				@click="continueBtn.actions(textValue, [], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!plaidLinkRef.linkSuccess && !data.question.customerApp().plaidId"
			>
				{{ data.question.getLocalizationDisplay(continueBtn.label, data.language) }}
			</button>

			<div
				v-else
				class="plaid-link-container"
			>
				<PlaidLink
					ref="plaidLink"
					:linkConfig="plaidConfig"
					:storeCode="data.application.storeCode"
					:launchText="launchText"
					@identityVerified="verificationObjToSave"
					:debugMode="isSaturnProduction"
				/>
			</div>
		</div>

		<div v-if="isBusyCheckingCredit">loading</div>
	</div>
</template>

<script>
	import LOCALIZATION from '@core/classes/Localization';
	import PlaidLink from '@core/components/PlaidLink.vue';
	import LoaderComponent from '@core/components/UI/LoaderComponent.vue';
	import { required, minLength, maxLength, numeric, between } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';
	import settings from 'settings';

	import ENUMS from '@core/classes/Enums';
	import { PlaidUserInfo } from '@core/classes/Plaid/PlaidUserInfo';
	import DocumentAssociation from '@core/classes/DocumentAssociation';
	import PlaidLinkConfig from '@core/classes/Plaid/PlaidLinkConfig';

	export default {
		name: 'QuestionPlaidLink',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				isBusyCheckingCredit: false,
				continueBtn: {},
				procedeWithoutPlaidLink: {},
				textValue: null,
				plaidConfig: null,
				launchText: null,
				plaidLinkRef: {}, //empty obj to prevent error in the watch
			};
		},
		computed: {
			localization() {
				return LOCALIZATION;
			},
			ENUMS() {
				return ENUMS;
			},
			settings() {
				return settings;
			},
			isSaturnProduction() {
				return this.settings.environmentName === 'PRODUCTION';
			},
		},
		async created() {
			this.continueBtn = this.data.question.getAnswers().filter(q => q.label == 'continue')[0];
			// console.log(this.continueBtn)

			//updated starts
			this.procedeWithoutPlaidLink = this.data.question.getAnswers().filter(q => q.label == 'procedeWithoutPlaidLink')[0];
			this.launchText = this.getLaunchText();

			//updated ends
			this.textValue = this.data.question.savedAnswer;
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
					this.launchText = this.getLaunchText();
				},
				{ deep: true },
			);

			this.plaidConfig = new PlaidLinkConfig({
				name: 'Saturn',
				associations: [
					new DocumentAssociation({
						type: ENUMS.DOC_ASSOCIATION.CustomerApplication,
						id: this.data.question.customerApp().id,
					}),
				],
				userData: this.getPlaidUser(),
				productsToInit: [ENUMS.PLAID_PRODUCTS.IdentityVerification],
				countries: [ENUMS.PLAID_COUNTRIES.UnitedStates],
			});

			this.$watch(
				() => this.plaidLinkRef.isBusy,
				newValue => {
					if (!newValue) {
						this.$nextTick(() => {
							const el = this.plaidLinkRef.$el.querySelector('.launch-link-button');
							if (el) {
								el.style.margin = '0';
								el.style.padding = '15px 30px';
								el.style.background = this.theme[this.continueBtn.style.background];
								el.style.color = this.theme[this.continueBtn.style.text];
								el.style.border = '0';
								el.style.maxWidth = 'none';
								el.style.width = '100%';
							}
						});
					}
				},
			);
		},
		mounted() {
			this.plaidLinkRef = this.$refs.plaidLink;
		},
		validations() {
			//if (this.data.question.GetValidation) {
			//    return this.data.question.GetValidation();
			//} else {
			//    return {
			//        textValue: {}
			//    }
			//}
		},
		methods: {
			verificationObjToSave(data) {
				this.textValue = data.plaidResponse;
			},
			getLaunchText() {
				return this.data.language == 'English' ? 'Verify Identity' : 'Verificar Identidad';
			},
			getPlaidUser() {
				if (this.settings.plaidEnvironment !== 'PRODUCTION') return PlaidUserInfo.getSandboxUser();

				const personalInfo = this.data.application.quoteAppData.applicationsDataAnswered.personalInfo;
				const plaidUser = new PlaidUserInfo({
					emailAddress: personalInfo.emailAddress,
					phoneNumber: `+1${this.data.application.preFilledData.phoneNumber}`,
					name: {
						givenName: personalInfo.firstName,
						familyName: personalInfo.lastName,
					},
					dateOfBirth: personalInfo.dateOfBirth,
					address: {
						street: personalInfo.currentResidence.addressLine1,
						city: personalInfo.currentResidence.city,
						region: personalInfo.currentResidence.state,
						postalCode: personalInfo.currentResidence.zipCode,
						country: personalInfo.currentResidence.country,
					},
				});

				if (personalInfo.ssnHashed) {
					plaidUser.idNumber = {
						value: personalInfo.ssnHashed,
						type: ENUMS.PLAID_ID_TYPES.UnitedStatesSSN,
					};
					plaidUser.isIdEncrypted = true;
				}

				return plaidUser;
			},
		},
		components: {
			PlaidLink,
			LoaderComponent,
		},
	};
</script>

<style>
	.plaid-link-container {
		display: flex;
		justify-content: flex-end;
	}

	.continue-without-plaid {
		display: flex;
		justify-content: center;
		padding: 10px;
		justify-content: flex-start;
		flex-basis: 100%;
		position: absolute;
		bottom: 145%;
	}

	.continue-without-plaid button {
		max-width: unset !important;
	}

	.btn-text {
		background: none !important;
		padding: 5px;
		text-decoration: underline;
		padding: 10px;
		color: black !important;
		font-size: 16px !important;
	}

	.note-text {
		margin-top: -20px;
		margin-bottom: 20px;
		font-size: 18px;
	}

	.saturn-textbox .saturn-textbox-error-message {
		display: none;
	}

	.launch-link-button {
		width: 50%;
		padding: 10px;
	}

	#plaid-success-text {
		align-self: center;
		text-align: center;
		color: var(--success-color);
	}
</style>
